import React from 'react';
import { ReactComponent as CalendarSVG } from './calendardots.svg';

export default function CalendarIcon({width = 28, height = 28, color = 'black'})
{
  return (
    <CalendarSVG
      width={width}
      height={height}
      style={{color: color}}
    />
  );
}